import React from "react";

const AnimeImage = ({ animeInfo, screenWidth }) => {
  return (
    <div>
      <div className="md:pr-sm flex flex-col justify-center content-center w-full items-center md:w-auto">
        <div
          id="poster-image"
          className="w-[300px] h-[500px] md:w-[400px] md:h-[700px]  bg-no-repeat bg-cover bg-center"
          style={
            screenWidth > 768
              ? {
                  backgroundImage: `url(${animeInfo.images.webp.large_image_url})`,
                }
              : {
                  backgroundImage: `url(${animeInfo.images.webp.large_image_url})`,
                }
          }
          alt={animeInfo.title}
        />
        <div className="flex flex-row w-full justify-between items-center my-sm text-center">
          <div className="">
            <h2 className="font-display text-nav md:text-m">Rating</h2>
            <p className="font-body text-s leading-body">
              {animeInfo.score ? animeInfo.score : "N/A"}
            </p>
          </div>
          <div className="w-zero h-sm border border-white/40 "></div>
          <div>
            <h2 className="font-display text-nav md:text-m">Episodes</h2>
            <p className="font-body text-s leading-body">
              {animeInfo.episodes}
            </p>
          </div>
          <div className="w-zero h-sm border border-white/40 "></div>
          <div>
            <h2 className="font-display text-nav md:text-m">Duration</h2>
            <p className="font-body text-s leading-body">
              {animeInfo.duration}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimeImage;
